import React from 'react';
import { ListIcon, ChevronRightIcon } from 'lucide-react';
const tableOfContents = [{
  id: 'preamble',
  label: 'Preamble'
}, {
  id: 'article-i',
  label: 'Article I — Name'
}, {
  id: 'article-ii',
  label: 'Article II — Object'
}, {
  id: 'article-iii',
  label: 'Article III — Membership'
}, {
  id: 'article-iv',
  label: 'Article IV — Officers'
}, {
  id: 'article-v',
  label: 'Article V — Duties of Officers'
}, {
  id: 'article-vi',
  label: 'Article VI — Meetings'
}, {
  id: 'article-vii',
  label: 'Article VII — Board of Directors'
}, {
  id: 'article-viii',
  label: 'Article VIII — Committees'
}, {
  id: 'article-ix',
  label: 'Article IX — Dues and Fees'
}, {
  id: 'article-x',
  label: 'Article X — Amendments'
}, {
  id: 'article-xi',
  label: 'Article XI — Parliamentary Authority'
}, {
  id: 'bylaws',
  label: 'By-Laws'
}];
export function TableOfContents() {
  return <div className="w-full pt-12 md:pt-16" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-781">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-782">
        <div className="bg-white rounded-xl overflow-hidden shadow-sm border" style={{
        borderColor: '#ede9e0'
      }} data-id="element-783">
          <div className="p-4 flex items-center gap-3" style={{
          backgroundColor: '#1e3d2f'
        }} data-id="element-784">
            <ListIcon size={20} style={{
            color: '#c8a84b'
          }} data-id="element-785" />
            <h2 className="text-base font-bold uppercase" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#ffffff'
          }} data-id="element-786">
              Table of Contents
            </h2>
          </div>
          <div className="p-5" data-id="element-787">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2" data-id="element-788">
              {tableOfContents.map(item => <a key={item.id} href={`#${item.id}`} className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors hover:bg-gray-50" style={{
              color: '#1e3d2f',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-789">
                  <ChevronRightIcon size={14} style={{
                color: '#c8a84b'
              }} data-id="element-790" />
                  {item.label}
                </a>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
}